import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const AssessmentFlowChatPage = Loadable(
  lazy(() => import("../../MainAppView/Flows/Assessment/AssessmentFlowChatPage")),
);
const AssessmentFlowViewPage = Loadable(
  lazy(() => import("../../MainAppView/Flows/Assessment/AssessmentFlowViewPage")),
);
const AssessmentFlowsPage = Loadable(
  lazy(() => import("../../MainAppView/Flows/Assessment/AssessmentFlowsPage")),
);

export function FlowRoutes() {
  return (
    <>
      {/* Assessment flow */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AssessmentFlowRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ASSESSMENT_FLOWS())}
        render={() => <AssessmentFlowsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.AssessmentFlowRead]}
        permissionsAny={[AppPermission.FleetAppAccess, AppPermission.FleetCustomerAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ASSESSMENT_FLOW_VIEW())}
        render={() => <AssessmentFlowViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.AssessmentFlowRead]}
        permissionsAny={[AppPermission.FleetAppAccess, AppPermission.FleetCustomerAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ASSESSMENT_FLOW_CHAT_VIEW())}
        render={() => <AssessmentFlowChatPage />}
      />
    </>
  );
}
